<template>
  <model-form
    ref="modelForm"
    :model="orderCollectionDisplayType"
    modal-type="modal"
    width="600px"
  >
    <div class="column">
      <div class="row items-center q-mb-md">
        <model-form-input
          field="name"
          class="col"
          label="Name"
          autofocus
          :rules="[val => !$_.isEmpty(val) || 'Field is required']"
        />
      </div>
      <div class="row items-center q-mb-md">
        <model-form-select
          ref="salesLocationsSelect"
          field="salesLocationIds"
          class="col"
          label="Sales Locations"
          stack-label
          :options="locations.data"
          option-label="displayName"
          option-value="id"
          map-options
          emit-value
          multiple
          use-chips
          :rules="[
            val => !$_.isEmpty(val) || orderCollectionDisplayType.excludeSalesLocations || 'At least one location must be selected'
          ]"
          :hint="$t('orderCollection.hint.salesLocations', { exclude: orderCollectionDisplayType.excludeSalesLocations })"
        />
        <model-form-checkbox
          field="excludeSalesLocations"
          label="Exclude"
          @update:model-value="validateSalesLocationsSelect"
        />
      </div>
      <div class="row items-center q-mb-md">
        <model-form-select
          ref="itemSourceLocationsSelect"
          field="itemSourceLocationIds"
          class="col"
          label="Item Source Locations"
          stack-label
          :options="locations.data"
          option-label="displayName"
          option-value="id"
          map-options
          emit-value
          multiple
          use-chips
          :rules="[
            val => !$_.isEmpty(val) || orderCollectionDisplayType.excludeItemSourceLocations || 'At least one location must be selected'
          ]"
          :hint="$t('orderCollection.hint.itemSourceLocations', { exclude: orderCollectionDisplayType.excludeItemSourceLocations })"
        />
        <model-form-checkbox
          field="excludeItemSourceLocations"
          label="Exclude"
          @update:model-value="validateItemSourceLocationsSelect"
        />
      </div>
      <div class="row q-col-gutter-md items-center q-mb-md">
        <model-form-checkbox
          field="shouldIncludeRemoteOrders"
          class="col-6"
          label="Include Online Orders"
        >
          <q-tooltip>
            Include online orders in the order collection status display.
          </q-tooltip>
        </model-form-checkbox>
        <model-form-input
          field="readyToCollectExpirationMinutes"
          class="col-6"
          label="Ready to Collect Expiration Minutes"
          type="number"
          value-type="Number"
          :rules="[val => !$_.isNil(val) || 'Field is required']"
        >
          <q-tooltip>
            The number of minutes after an order is marked as delivered that it will remaing on the order collection display.
          </q-tooltip>
        </model-form-input>
      </div>
    </div>
  </model-form>
</template>

<script>
import ModelForm from 'src/modules/admin/components/ModelForm/ModelForm'

export default {
  name: 'OrderCollectionDisplayTypeForm',
  components: {
    ModelForm
  },
  configuration: ['locations'],
  methods: {
    validateSalesLocationsSelect () {
      this.$refs.salesLocationsSelect.validate()
    },
    validateItemSourceLocationsSelect () {
      this.$refs.itemSourceLocationsSelect.validate()
    }
  },
  models: {
    orderCollectionDisplayType: {
      salesLocations: {
        fields: ['id', 'name'],
        locationGroup: {
          fields: ['id', 'name']
        }
      },
      itemSourceLocations: {
        fields: ['id', 'name'],
        locationGroup: {
          fields: ['id', 'name']
        }
      }
    }
  }
}
</script>
